// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_DESCRIPTION_HEADER = "Popis";
export const BZ2_EDIT_ESHOP_URL_HEADER = "Webov\u00e1 adresa produktu";
export const BZ2_EDIT_PHOTO_HEADER = "Fotky";
export const BZ2_EDIT_PRICE_HEADER = "Cena";
export const BZ2_EDIT_SALARY_HEADER = "Mzda";
export const BZ2_EDIT_SALARY_PER_HEADER = "Mesa\u010dne / hodinov\u00e1 mzda";
export const BZ2_EDIT_SALARY_PER_HOUR = "Hodinov\u00e1 mzda";
export const BZ2_EDIT_SALARY_PER_MONTH = "Mesa\u010dne";
export const BZ2_EDIT_TITLE_HEADER = "N\u00e1zov inzer\u00e1tu";
export const BZ2_FACET_CATEGORY = "Kateg\u00f3ria";
export const BZ2_FACET_COUNTRY = "Krajina";
export const BZ2_FACET_COUNTY = "Okres";
export const BZ2_FACET_PLACE = "Obec";
export const BZ2_FACET_QUALITY2 = "Pou\u017eit\u00fd tovar / Vlastn\u00e1 v\u00fdroba / Nov\u00fd tovar / Slu\u017eby";
export const BZ2_GET_PLAN = "Aktivuj si";
export const BZ2_HANDMADE_PRODUCT_HOVER = "Vlastn\u00e1 v\u00fdroba";
export const BZ2_NEW_PRODUCT_HOVER = "Nov\u00fd tovar";
export const BZ2_OLD_PRODUCT_HOVER = "Pou\u017eit\u00fd tovar";
export const BZ2_QUALITY_YOU_HAVE_count_OF_max = "(m\u00e1\u0161 %(count)s z %(max)s)";
export const BZ2_SERVICES_PRODUCT_HOVER = "Slu\u017eby";
export const BZ2_SUGGEST_CATEGORY_CATEGORY = "Odpor\u00fa\u010dan\u00e9 kateg\u00f3rie";
export const BZ2_UNLIMITED = "neobmedzene";
export const BZ_IN_STOCK_LABEL = "Tovar m\u00e1m skladom (ihne\u010f k dispoz\u00edcii)";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const FORMS_DEFAULT_URL_FIELD_FORMAT_ERROR = "Toto nevyzer\u00e1 ako spr\u00e1vna url adresa.";
export const HERE = "tu";
export const NEW_STROLLER_ONLY_WITH_XML_MOBILE_url = "Iba cez XML feed, viac inform\u00e1cii %(url)s";
export const NEW_STROLLER_ONLY_WITH_XML_url = "Ide prida\u0165 len cez XML feed. Viac inform\u00e1cii %(url)s";
export const PRODUCT_CREATE_EDIT_FORM_I_WANT_TO_PICK_CATEGORY_MANUALLY = "Chcem vybra\u0165 in\u00fa kateg\u00f3riu, uk\u00e1\u017e mi v\u0161etky...";
export const PRODUCT_CREATE_EDIT_FORM_LOADING_SUGGESTIONS = "H\u013ead\u00e1m kateg\u00f3riu...";
export const PRODUCT_CREATE_EDIT_FORM_PHOTOS_FAILED = "Fotky sa nepodarilo nahra\u0165.";
export const PRODUCT_CREATE_EDIT_FORM_UPLOAD_SCREEN_INFO_icon = "%(icon)s je hlavn\u00e1 fotka inzer\u00e1tu.";
export const PRODUCT_CREATE_EDIT_JOBS_CATEGORY_QUALITY = "Pr\u00e1ce a brig\u00e1dy musia ma\u0165 typ produktu Pr\u00e1ca.";
export const PRODUCT_CREATE_EDIT_JOBS_QUALITY_NEEDS_JOBS_CATEGORY = "Pr\u00e1ca mus\u00ed by\u0165 v kateg\u00f3rii Pr\u00e1ce a brig\u00e1dy";
export const PRODUCT_CREATE_EDIT_MODEL_DO_NOT_MATCH_BRAND = "Vybrat\u00fd model v danej zna\u010dke neexistuje";
export const PRODUCT_CREATE_EDIT_ONLY_ONE_VALUE_ALLOWED = "Povolen\u00e1 je iba jedna vlastnos\u0165.";
export const PRODUCT_CREATE_EDIT_SERVICES_CATEGORY_QUALITY = "Slu\u017eby musia ma\u0165 typ produktu Slu\u017eba.";
export const PRODUCT_CREATE_EDIT_SERVICES_QUALITY_NEEDS_SERVICES_CATEGORY = "Slu\u017eby musia by\u0165 v kateg\u00f3rii Slu\u017eby";
export const SELECT_CATEGORY = "Vyber kateg\u00f3riu";
